import { Link } from "react-router-dom";
import { Sketch } from "./Sketches";
import { Reveal, Sticky } from "./NoteBlocks";

const Stat = ({ v, l }) => (
  <div><p className="font-display text-5xl leading-none">{v}</p><p className="text-[13px] text-[#4A4A55] mt-1">{l}</p></div>
);

export const IntroPage = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20" data-testid="intro-section">
    <div className="notebook-page">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <Reveal>
          <p className="eyebrow">Page 00 · before module 01</p>
          <h2 className="font-display text-5xl sm:text-6xl text-[#1F2A44] mt-3 leading-[0.95]">Digital vs Performance — the one-minute version.</h2>
          <p className="mt-5 leading-relaxed text-[#2E2E38]">
            <b>Digital marketing</b> = promoting your business online. <b>Performance marketing</b> = focusing on <span className="hl">measurable results</span> from that promotion — leads, sales, revenue, profit.
          </p>
          <Link to="/module/marketing-fundamentals#dm-vs-pm" className="pill-btn mt-7 inline-flex" data-testid="intro-full-comparison-link">See the full comparison</Link>
        </Reveal>
        <Reveal delay={0.1}><Sketch name="spendToRevenue" caption="fig 0.1 — spend less to get a lead, scale the revenue" /></Reveal>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-14">
        <Reveal>
          <Sticky color="pink" rotate={-1} testId="intro-dm-example">
            <p className="text-xs uppercase tracking-[0.2em]">Digital marketing example</p>
            <div className="flex gap-10 mt-4"><Stat v="100K" l="Reel views" /><Stat v="2,000" l="New followers" /></div>
            <p className="font-hand text-lg mt-4">Your content helps people discover and recognise your brand.</p>
          </Sticky>
        </Reveal>
        <Reveal delay={0.1}>
          <Sticky color="green" rotate={1} testId="intro-pm-example">
            <p className="text-xs uppercase tracking-[0.2em]">Performance marketing example</p>
            <div className="flex gap-10 mt-4"><Stat v="₹10,000" l="Ad spend" /><Stat v="₹50,000" l="Sales generated" /></div>
            <p className="font-mono text-[13px] mt-4">ROAS = ₹50,000 ÷ ₹10,000 = 5x</p>
            <p className="font-hand text-lg mt-1">₹5 in tracked sales for every ₹1 spent. Not ₹5 profit!</p>
          </Sticky>
        </Reveal>
      </div>
    </div>
  </section>
);
